import { render, staticRenderFns } from "./sale-edit.vue?vue&type=template&id=0b0efe21&scoped=true&"
import script from "./sale-edit.vue?vue&type=script&lang=js&"
export * from "./sale-edit.vue?vue&type=script&lang=js&"
import style0 from "./sale-edit.vue?vue&type=style&index=0&id=0b0efe21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0efe21",
  null
  
)

export default component.exports